export const noEmptyVaildation = (name) => {
  const regex = "[a-zA-Z0-9_]+.*$";
  return name.length > 0 && name.match(regex);
};
